import {Component, Input, OnInit} from '@angular/core';
import {ReportService} from "../../../services/report.service";
import {EmailService} from "../../../services/email.service";
import {icJWT_Account, ReportEmailLog, ReportRecord} from "../../../NIBINInterface";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-email-logs',
  templateUrl: './email-logs.component.html',
  styleUrls: ['./email-logs.component.css'],
  providers: [EmailService,ReportService]
})
export class EmailLogsComponent implements OnInit {
  user: icJWT_Account = <icJWT_Account>{};
  @Input('ReportInfo') ReportInfo:ReportRecord = <ReportRecord>{}

  EmailLog: ReportEmailLog[] = [];

  constructor(private authService: AuthService,private emailService: EmailService,private reportService: ReportService) {
    this.user = this.authService.getUser()
  }
  ngOnInit(): void {
    this.emailService.getEmailReportLogs(this.ReportInfo.ReportID ?? '').then((r:ReportEmailLog[])=>{
      this.EmailLog=r;
    })
  }

}
